import "../../../../resources/less/Troubadour/Babillard/popups/ShareBabillardPopup.less";
import RestPromise from "../../../utils/RestPromise";
import MultiPanelsNanoPopup from "../../../components/Popups/MultiPanelsNanoPopup";
import { IPaywallPopup } from "../../../Troubadour/Paywall/IPaywallPopup";

export default class FamilySubscriptionPopup
  extends MultiPanelsNanoPopup
  implements IPaywallPopup
{
  private activationCodeInput: JQuery<HTMLInputElement>;
  private codeCorrect: boolean = false;

  constructor() {
    super({
      target: "#family-sub-required-popup",
      onHide: () => {
        this.showError("");
        this.activationCodeInput.val("");

        if (this.codeCorrect) {
          location.reload();
        }
      },
    });
    // Scope to this popup: teacher pages also contain the generic paid-feature
    // popup, which has its own .activation-code input and .error-message
    this.activationCodeInput = this.currentTarget.find(".activation-code");

    this.currentTarget.find(".code-button").on("click", () => {
      this.goTo(1);
    });

    this.currentTarget.find(".code-confirm-button").on("click", () => {
      this.checkCode();
    });

    this.activationCodeInput.on("change", () => {
      this.showError("");
    });
  }

  public get featureName(): string {
    return this.currentTarget.attr("data-feature-name");
  }

  public set featureName(value: string) {
    this.currentTarget.attr("data-feature-name", value);
  }

  private checkCode() {
    const code = this.activationCodeInput.val();
    if (code) {
      RestPromise.Create("/rest/licence/code", "POST", { code: code })
        .then(() => {
          this.goTo(2);
          this.codeCorrect = true;
        })
        .catch((error: { responseData: { message: string } }) => {
          this.showError(error.responseData.message);
        });
    }
  }

  private showError(error: string) {
    this.currentTarget.find(".error-message").text(error);
  }
}
